<!-- 十字表格 -->
<template>
    <div v-if="componentsData.type == 22">
        <div class="bg-div" :style="bgStyle">
            <div
                v-if="componentsData.content.title"
                :style="titleStyle"
                class="title-box"
            >
                {{ componentsData.content.title }}
            </div>
            <div class="table-box">
                <table>
                    <tbody>
                        <tr
                            v-for="(e, i) in componentsData.content.table_list"
                            :key="i"
                            :style="txtStyle2"
                        >
                            <td
                                :style="{
                                    ...txtStyle1,
                                    ...borderStyle,
                                    ...titleStyle,
                                }"
                                class="w100"
                            >
                                {{ e.label }}
                            </td>
                            <td :style="borderStyle">
                                {{
                                    e.type == "1" ||
                                    e.type == "7" ||
                                    e.type == "8"
                                        ? "请选择"
                                        : "请输入"
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        borderStyle() {
            const content = this.componentsData.content;
            return {
                border: `1px solid ${content.border_color}`,
            };
        },
        txtStyle1() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.title_background_color,
            };
        },
        txtStyle2() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.fill_color,
            };
        },
        titleStyle() {
            const content = this.componentsData.content;
            return {
                color: content.title_color,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.table-box table {
    width: 100%;
    border-collapse: collapse;
}
.table-box td {
    padding: 6px;
    color: #ccc;
}
.title-box {
    margin-bottom: 8px;
    font-size: 18px;
}
.w100 {
    width: 110px;
}
</style>
